export const SERVER_URI = process.env.REACT_APP_MODE === 'DEVELOPMENT'
  ? process.env.REACT_APP_DEV_API_URL
  : process.env.REACT_APP_PROD_API_URL;

export const DEFAULT_LANDING = process.env.REACT_APP_DEFAULT_LANDING;

export const DEFAULT_POLLING_INTERVAL = 300000; // 5 Minutes

export const APPLICATION_NAME = process.env.REACT_APP_BASENAME;

export const APPLICATION_VERSION = process.env.REACT_APP_CURRENT_VERSION;

export const APPLICATION_ID = process.env.REACT_APP_ID;

export const APPLICATION_MODE = process.env.REACT_APP_MODE;

export const STORAGE_KEYS = {
  CART: 'cart',
  WISHLIST: 'wishlist'
} as const;
